import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { getPurchaseEmail, getIsMandatory } from 'client/contexts/Purchase/selectors'
import { mapVoucherToTracking } from 'src/comps/Voucher/mappers'
import { typeAny, typeProperty } from 'client/types'
import { typeConfig } from 'src/comps/Page/types'
import { typePaymentMethods } from 'client/types/checkout'

import Head from 'client/pages/Home/Head'
import Header from 'client/components/Header'
import MessageHeader from 'client/components/VoucherHeader/MessageHeader'
import Page from 'src/comps/Page'
import Voucher from 'src/comps/Voucher/container'

import { Layout } from 'client/pages/styles'
import { CheckoutProvider } from 'client/components/CheckoutContainer/context'
import { QueryClient, QueryClientProvider } from 'react-query'
import { getServerSideProps as getServerSidePropsHandler } from 'src/pages/booking/voucher/[purchaseId]/server'
import { useMarket } from 'src/hooks/useMarket'
import KindlyChat from 'src/comps/KindlyChat'

const pageId = 'voucher'

const VoucherPage = ({
  config,
  translations,
  purchaseId,
  paymentMethods,
  voucher,
  property,
  ancillariesJSON,
  supportInfoJSON,
}) => {
  const bookingStatuses = voucher?.bookings?.map(item => item.bookingStatus)

  const isMandatory = useSelector(getIsMandatory)
  const purchaseEmail = useSelector(getPurchaseEmail)
  const { contactEmail } = useMarket()

  const trackingData = {
    ...config,
    ...mapVoucherToTracking(voucher),
    isMandatory,
    purchaseEmail,
  }

  const [queryClient] = useState(() => new QueryClient())

  return (
    <Page config={config} pageId={pageId} trackingData={trackingData} translations={translations}>
      <Layout>
        <Head language={config.language} market={config.market} />
        <Header
          pageId={pageId}
          contactEmail={contactEmail}
          hasDirectSales={false}
          ancillariesJSON={ancillariesJSON}
        />
        <MessageHeader statuses={bookingStatuses} consumer="voucher" />

        <CheckoutProvider purchaseId={purchaseId}>
          <QueryClientProvider client={queryClient}>
            <Voucher
              pageId={pageId}
              paymentMethods={paymentMethods}
              purchaseId={purchaseId}
              voucher={voucher}
              property={property}
              supportInfoJSON={supportInfoJSON}
            />
          </QueryClientProvider>
        </CheckoutProvider>
        <KindlyChat purchaseId={purchaseId} />
      </Layout>
    </Page>
  )
}

VoucherPage.propTypes = {
  config: typeConfig,
  paymentMethods: typePaymentMethods,
  purchaseId: PropTypes.string,
  translations: typeAny,
  voucher: PropTypes.instanceOf(Object), // TODO : create type voucher
  property: typeProperty,
  ancillariesJSON: typeAny,
  supportInfoJSON: PropTypes.instanceOf(Object),
}

export const getServerSideProps = getServerSidePropsHandler

VoucherPage.pageId = pageId
VoucherPage.pagePathView = '/booking/voucher/[purchaseId]'

export default VoucherPage
